import React, { useEffect, useState } from 'react';
import { Grid, Button } from '@material-ui/core';

import { useStyles } from './styles';
import { ISupplierFilters } from './interfaces';
import { useGroupsGql } from '../../graphql/groups';
import { SearchBar } from 'components/migrated/searchbar';
import { DatePicker } from 'components/migrated/datepicker';
import { InAcessMoveis } from '../../graphql/groups/interfaces';
import { useSnackbar, useEnvironment } from '../../../../../hooks';
import { IOption } from '../../../../../components/migrated/enhancedautocomplete/interfaces';
import { EnhancedAutocomplete as Autocomplete } from '../../../../../components/migrated/enhancedautocomplete';

const dataDivisions = [
  {
    productDivisionKey: 'A',
    productDivisionName: 'Acessórios'
  },
  {
    productDivisionKey: 'P',
    productDivisionName: 'Móveis'
  }
];

export const SupplierFiltersBar = (props: ISupplierFilters) => {
  const { filters, setFilters } = props;
  const { runGroupsGql, dataGroups, errorGroups, loadingGroups } = useGroupsGql();
  const { DEBUG } = useEnvironment();
  const { Snackbar, toggleSnackbar } = useSnackbar();
  const classes = useStyles();

  const [selectedDivision, setSelectedDivision] = useState<IOption | null>(null);
  const [selectedGroup, setSelectedGroup] = useState<IOption | null>(null);
  const [searchTerm, setSearchTerm] = useState<string>('');
  const [selectedDate, setSelectedDate] = useState<Date | null>(null);

  const handleDivisionChange = (option: IOption | null) => {
    setSelectedDivision(option);
    if (!option) {
      setSelectedGroup(null);
    }
  };

  const handleGroupChange = (option: IOption | null) => {
    setSelectedGroup(option);
  };

  const handleSearch = (value: string) => {
    setSearchTerm(value);
  };

  const handleDateChange = (date: Date | null) => {
    setSelectedDate(date);
  };

  const handleClearFilters = () => {
    setSelectedDivision(null);
    setSelectedGroup(null);
    setSearchTerm('');
    setSelectedDate(null);
  };

  useEffect(() => {
    if (filters.productDivisionIndicator) {
      runGroupsGql({
        variables: {
          inAcessMoveis: filters.productDivisionIndicator!
        }
      });
    }
  }, [filters.productDivisionIndicator]);

  useEffect(() => {
    if (errorGroups) {
      if (DEBUG === 'TRUE') {
        console.log(`Erro ao carregar dados! Error:(message: ${errorGroups} )`);
      } else {
        toggleSnackbar({
          message: 'Ocorreu um problema ao carregar os fornecedores. Por favor, informe ao suporte.',
          type: 'error'
        });
      }
    }
  }, [errorGroups]);

  useEffect(() => {
    setFilters((prev) => ({
      ...prev,
      productDivisionIndicator: (selectedDivision?.key as InAcessMoveis) || null,
      productGroupId: selectedGroup ? Number(selectedGroup.key) : null,
      productId: searchTerm ? Number(searchTerm) : null,
      receiptDate: selectedDate ?? null
    }));
  }, [selectedDivision, selectedGroup, searchTerm, selectedDate]);

  return (
    <>
      <Snackbar />
      <div className={classes.root}>
        <Grid container spacing={1}>
          <Grid item xs={12} sm={6} md={6} lg={2}>
            <Autocomplete
              data={dataDivisions}
              keyProperty="productDivisionKey"
              valueProperty="productDivisionName"
              onChange={handleDivisionChange}
              value={selectedDivision}
              label="Selecione a divisão"
              defaultValue={''}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={3}>
            <Autocomplete
              showKeyProperty
              data={dataGroups}
              keyProperty="productGroupId"
              valueProperty="productGroupName"
              onChange={handleGroupChange}
              value={selectedGroup}
              label="Selecione o grupo"
              defaultValue={''}
              loading={loadingGroups}
              disabled={!filters.productDivisionIndicator}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <SearchBar
              onSearch={handleSearch}
              label="Id Produto"
              searchTerm={searchTerm}
              onClearSearch={() => setSearchTerm('')}
            />
          </Grid>

          <Grid item xs={12} sm={6} md={6} lg={2}>
            <DatePicker
              label="Dt. Recebimento"
              onChange={handleDateChange}
              selected={selectedDate}
              value={selectedDate}
            />
          </Grid>

          <Grid item xs={6} sm={6} md={6} lg={1}>
            <div className={classes.buttonPosition}>
              {(selectedDivision || selectedGroup || selectedDate || searchTerm) && (
                <Button className={classes.clearAllButton} color="primary" onClick={handleClearFilters}>
                  {'LIMPAR FILTROS'}
                </Button>
              )}
            </div>
          </Grid>
        </Grid>
      </div>
    </>
  );
};
